(function () {
  'use strict';

  function initSlrWidgetDock() {
    var dock = document.getElementById('slrWidgetDock');
    var scrollUpButton = document.getElementById('slrScrollUp');
    var googleSlot = document.getElementById('slrGoogleWidgetSlot');
    var zipChatSlot = document.getElementById('slrZipChatWidgetSlot');

    if (!dock || dock.dataset.initialized === 'true') return;
    dock.dataset.initialized = 'true';

    if (scrollUpButton) {
      var scrollUpStage = 0;

      function resetScrollUpStage() {
        scrollUpStage = 0;
      }

      window.addEventListener('wheel', resetScrollUpStage, { passive: true });
      window.addEventListener('touchstart', resetScrollUpStage, { passive: true });

      scrollUpButton.addEventListener('click', function () {
        var root = document.documentElement;
        var maxScroll = Math.max(0, root.scrollHeight - window.innerHeight);
        var midpoint = Math.round(maxScroll / 2);
        var currentScroll = window.scrollY || root.scrollTop || 0;
        var target = 0;

        if (scrollUpStage === 0 && currentScroll > midpoint + 40) {
          target = midpoint;
          scrollUpStage = 1;
        } else {
          scrollUpStage = 0;
        }

        window.scrollTo({ top: target, left: 0, behavior: 'smooth' });

        if (typeof window.slLoadDeferredAnalytics === 'function') {
          window.slLoadDeferredAnalytics('seitenhilfe_scroll_up');
        }
      });
    }

    function alignGoogleWidget(iframe) {
      if (!googleSlot || !iframe || iframe.dataset.slrAligned === 'true') return;

      var wrapper = iframe.parentElement;
      if (!wrapper || wrapper.id !== 'google-merchantwidget-iframe-wrapper') return;

      function positionGoogleWidget() {
        var slotRect = googleSlot.getBoundingClientRect();
        var viewportWidth = document.documentElement.clientWidth;
        var triggerRight = slotRect.left + slotRect.width / 2 + 36;
        var triggerBottom = slotRect.top + slotRect.height / 2 + 36;
        var right = Math.max(0, Math.round(viewportWidth - triggerRight));
        var bottom = Math.max(0, Math.round(window.innerHeight - triggerBottom));

        if (wrapper.style.getPropertyValue('right') !== right + 'px') {
          wrapper.style.setProperty('right', right + 'px', 'important');
        }
        if (wrapper.style.getPropertyValue('bottom') !== bottom + 'px') {
          wrapper.style.setProperty('bottom', bottom + 'px', 'important');
        }
      }

      positionGoogleWidget();
      var googlePositionObserver = new MutationObserver(positionGoogleWidget);
      googlePositionObserver.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
      window.addEventListener('resize', positionGoogleWidget, { passive: true });
      iframe.dataset.slrAligned = 'true';
    }

    function connectWidgets() {
      var googleIframe = document.querySelector('#merchantwidgetiframe');
      var googleConnected = Boolean(googleIframe);

      if (googleConnected && googleSlot) {
        alignGoogleWidget(googleIframe);
        googleSlot.classList.add('is-connected');
      }
      var zipChatHost = document.querySelector('#zipchat-shadow-host');
      var zipChatButton = zipChatHost && zipChatHost.shadowRoot
        ? zipChatHost.shadowRoot.querySelector('#widget-chat-button')
        : null;
      var zipChatConnected = Boolean(zipChatHost && zipChatButton);

      if (zipChatConnected && zipChatSlot && !zipChatSlot.classList.contains('is-connected')) {
        var shadowRoot = zipChatHost.shadowRoot;

        if (!shadowRoot.querySelector('#slr-zipchat-dock-style')) {
          var zipChatStyle = document.createElement('style');
          zipChatStyle.id = 'slr-zipchat-dock-style';
          zipChatStyle.textContent = '#widget-chat-container{position:fixed!important;right:26px!important;bottom:38px!important;left:auto!important;top:auto!important;width:72px!important;height:72px!important;overflow:visible!important;z-index:2147483646!important;transform:none!important;}#widget-chat-button{position:absolute!important;inset:0!important;width:72px!important;height:72px!important;opacity:.001!important;pointer-events:auto!important;transform:none!important;}@media(max-width:768px){#widget-chat-container{right:15px!important;bottom:22vh!important;width:64px!important;height:64px!important;}#widget-chat-button{width:64px!important;height:64px!important;}}';
          shadowRoot.appendChild(zipChatStyle);
        }

        zipChatSlot.classList.add('is-connected');
      }

      if (googleConnected && zipChatConnected && observer) {
        observer.disconnect();
        observer = null;
      }
    }

    var observer = new MutationObserver(connectWidgets);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    connectWidgets();

    var zipChatWait = window.setInterval(function () {
      connectWidgets();
      if (zipChatSlot && zipChatSlot.classList.contains('is-connected')) {
        window.clearInterval(zipChatWait);
      }
    }, 250);

    window.setTimeout(function () {
      if (observer) observer.disconnect();
      window.clearInterval(zipChatWait);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlrWidgetDock, { once: true });
  } else {
    initSlrWidgetDock();
  }
})();
